import { IStateContextData } from '../interfaces/state.interfaces';
import { feetInchesToCm } from './forms.helpers';

export const getCmFromHeightObj = (
  data: IStateContextData['height'],
): number => {
  if (!data?.isMetric) return feetInchesToCm(data?.ft, data?.in);
  return data?.cm || 0;
};

interface IInchesToFeet {
  feet: number;
  inches: number;
  formatted: string;
}

export const inchesToFeet = (
  totalInches: number | undefined = 0,
): IInchesToFeet => {
  if (!totalInches) return { feet: 0, inches: 0, formatted: '0\'0"' };

  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);

  return {
    feet,
    inches,
    formatted: `${feet}'${inches}"`,
  };
};

interface ICmToFeetInches extends IInchesToFeet {
  totalInches: number;
}

export const cmToFeetInches = (cm: number | undefined = 0): ICmToFeetInches => {
  // INFO: 1 inch = 2.54 cm
  const totalInches = Math.round(cm > 0 ? cm / 2.54 : 0);

  return {
    totalInches,
    ...inchesToFeet(totalInches),
  };
};
